import BaseModel from '../base/BaseModel.model';
import TipoEvaluacion from './tipoEvaluacion.model';
import PreguntaOpcionRespuesta from './pregunta-opcion-respuesta';

export default class Pregunta extends BaseModel {

    public titulo: string | null = null;
    public texto: string | null = null;
    public respuesta: string | null = null;
    public description: string | null = null;
    //public respuestaArr: Array<string> = new Array<string>();
    public orden: number = 0;
    public tipoEvaluacionId: number | null = null;
    public tipoEvaluacion: TipoEvaluacion | null = null;
    public preguntaOpcionRespuestas: Array<PreguntaOpcionRespuesta> = [];
    
    constructor(){
        super();
        this.init();
    }

    init(){}
}